import { Box, Text } from "@chakra-ui/react";
import ContabilizacaoTable from "../ContabilizacaoTable";
import { Flex } from "@chakra-ui/layout";
import { Control } from "react-hook-form";
import CollapsibleCard from "../CollapsibleCard";
import TiposContabilizacao from "./../TiposContabilizacao/index";
import RowTableRecebimentoVendas from "./RowTableRecebimentoVendas";
import { ExportacaoContabilForm } from "features/exportacao-contabil/typings";
import { FiltroExportacaoContabil } from "features/exportacao-contabil/typings";
import { Empty } from "antd";
export default function FormRecebimentoVendas({
  control,
  form,
  receitas,
  filtro,
}: {
  receitas?: {
    id: string;
    codigoIntegracao: string | null;
    nome: string;
    pessoas: {
      id: string;
      codigoIntegracao: string | null;
      nome: string;
    }[];
    valor: number;
  }[];
  control: Control<ExportacaoContabilForm, object>;
  form: ExportacaoContabilForm;
  filtro: FiltroExportacaoContabil;
}) {
  if (!receitas?.length) {
    return <Empty description="Nenhuma recebimento para exportar" />;
  }

  return (
    <Box>
      <CollapsibleCard
        titleCard="Entenda os diferentes tipos de contabilização"
        children={<TiposContabilizacao />}
      />

      <Text my={8}>
        Selecione a conta contábil das categorias de receita e de cliente.
      </Text>
      <ContabilizacaoTable
        headerTable={
          <Flex w="100%" gap={4}>
            <Flex flex={4} fontWeight="medium">
              Categorias analíticas/cliente
            </Flex>
            <Flex flex={2} fontWeight="medium">
              Tipo de Contabilização
            </Flex>
            <Flex flex={2} fontWeight="medium">
              Código reduzido
            </Flex>
            <Flex flex={2} />
          </Flex>
        }
        rowTable={receitas?.map((receita, index) => (
          <RowTableRecebimentoVendas
            form={form}
            key={receita.id}
            receita={receita}
            control={control}
            index={index}
            filtro={filtro}
          />
        ))}
      />
    </Box>
  );
}
